import { useContext } from "react";
import { ActiveTenantContext } from "../contexts";

export function useActiveTenant() {
  const activeTenantContext = useContext(ActiveTenantContext);

  return activeTenantContext;
}
